import { render, staticRenderFns } from "./leave-accrual-report.vue?vue&type=template&id=8b4966be"
import script from "./leave-accrual-report.vue?vue&type=script&lang=js"
export * from "./leave-accrual-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports